/* SPEKTRX Neon Terminal — shared motion kit. Use: SPK.aurora(), SPK.countUp(...), etc. */
const SPK = (() => {
  const NS = 'http://www.w3.org/2000/svg';
  const COLS = [[0,240,255],[255,43,214],[52,226,160],[70,120,255]];

  /* animated aurora / smoke background. opts: {density, intensity} */
  
  // Reduced-motion gate (audit 2026-07-13 P4): JS-driven perpetual animations
  // (aurora rAF, tickers, bubble physics) must honor the OS setting — CSS
  // rules cannot stop rAF/setInterval loops.
  const _rmq = typeof matchMedia === 'function' ? matchMedia('(prefers-reduced-motion: reduce)') : null;
  function motionOK() { return !(_rmq && _rmq.matches); }

  function aurora(opts={}){
    let cv=document.getElementById('aurora');
    if(!cv){cv=document.createElement('canvas');cv.id='aurora';document.body.prepend(cv);}
    const ctx=cv.getContext('2d');let W,H;
    const N=opts.density||6, I=opts.intensity||1;
    function resize(){const r=devicePixelRatio||1;W=cv.width=innerWidth*r;H=cv.height=innerHeight*r;cv.style.width=innerWidth+'px';cv.style.height=innerHeight+'px';}
    resize();addEventListener('resize',resize);
    // positioned color seeds → purple/magenta on the LEFT, green/cyan on the RIGHT, blue centre. Very faint, gentle drift.
    // Dashboard (no opts.dominant) = full spectrum, original look. Each section passes opts.dominant (+accents) for its own color identity.
    let SEED;
    if(opts.dominant){
      const d=opts.dominant, ac=opts.accents||[];
      SEED=[{x:.12,y:.82,c:d,a:1.0},{x:.04,y:.46,c:d,a:.72},{x:.90,y:.70,c:d,a:.5},{x:.5,y:.16,c:d,a:.48}];
      ac.slice(0,2).forEach((c,i)=>SEED.push({x:i?.9:.62,y:i?.28:.6,c,a:.28}));
    } else {
      SEED=[
        {x:.13,y:.84,c:[167,139,250],a:1.0}, {x:.02,y:.50,c:[150,100,255],a:.7},
        {x:.62,y:.58,c:[0,210,200],a:.5},    {x:.93,y:.72,c:[52,226,160],a:.45},
        {x:.45,y:.18,c:[70,120,255],a:.5}
      ];
    }
    // gentle breeze drift (sheen was the real irritant, not this) — colors present, soft slow movement
    const blobs=SEED.map(s=>({bx:s.x,by:s.y,c:s.c,a:s.a,
      ax:.018+Math.random()*.01,ay:.018+Math.random()*.01,sx:.000012+Math.random()*.000006,sy:.00001+Math.random()*.000006,ph:Math.random()*6.28}));
    (function draw(t){
      ctx.clearRect(0,0,W,H);ctx.globalCompositeOperation='lighter';
      for(const b of blobs){
        const cx=(b.bx+Math.sin(t*b.sx+b.ph)*b.ax)*W, cy=(b.by+Math.cos(t*b.sy+b.ph)*b.ay)*H;
        const rad=.66*Math.max(W,H);
        const g=ctx.createRadialGradient(cx,cy,0,cx,cy,rad);const[r,gn,bl]=b.c;
        g.addColorStop(0,`rgba(${r},${gn},${bl},${.15*I*b.a})`);g.addColorStop(.5,`rgba(${r},${gn},${bl},${.05*I*b.a})`);g.addColorStop(1,'rgba(0,0,0,0)');
        ctx.fillStyle=g;ctx.beginPath();ctx.arc(cx,cy,rad,0,6.2832);ctx.fill();
      }
      ctx.globalCompositeOperation='source-over';if(motionOK())requestAnimationFrame(draw);
    })(0);
    return cv;
  }

  function countUp(el,target,opts={}){
    if(!el)return;const dur=opts.dur||1300,pre=opts.pre||'$',suf=opts.suf||'',dec=opts.dec||0,t0=performance.now();
    (function step(t){let p=Math.min((t-t0)/dur,1);p=1-Math.pow(1-p,3);
      el.textContent=pre+(target*p).toLocaleString('en-US',{maximumFractionDigits:dec,minimumFractionDigits:dec})+suf;
      if(p<1)requestAnimationFrame(step);})(t0);
  }

  /* draw-on area chart into an <svg>. pts REQUIRED — renders empty (never fabricated) when absent. */
  function areaChart(svg,pts,opts={}){
    if(!svg)return;const w=opts.w||820,h=opts.h||210;const animate=opts.animate!==false;
    if(!Array.isArray(pts)||pts.length<2){_stopTravel(svg);svg.innerHTML='';console.warn('[SPK] areaChart: no/insufficient data — rendering empty');return;}
    _stopTravel(svg); // kill prior travel loop before replacing nodes
    const max=Math.max(...pts),min=Math.min(...pts);
    const X=i=>i/(pts.length-1)*w,Y=val=>h-8-((val-min)/(max-min||1))*(h-30);
    let d='';pts.forEach((p,i)=>d+=(i?'L':'M')+X(i).toFixed(1)+' '+Y(p).toFixed(1)+' ');
    const area=d+`L ${w} ${h} L 0 ${h} Z`;
    svg.innerHTML=`<defs>
      <linearGradient id="af" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#00f0ff" stop-opacity=".28"/><stop offset="1" stop-color="#00f0ff" stop-opacity="0"/></linearGradient>
      <linearGradient id="ln" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#00f0ff"/><stop offset="1" stop-color="#ff2bd6"/></linearGradient>
      <linearGradient id="lnS" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#FF4D6A"/><stop offset=".2" stop-color="#FF8C42"/><stop offset=".4" stop-color="#D4A853"/><stop offset=".6" stop-color="#6EEEB4"/><stop offset=".8" stop-color="#4DC9F6"/><stop offset="1" stop-color="#9B4DFF"/></linearGradient></defs>
      <path d="${area}" fill="url(#af)" opacity="${animate?0:1}" id="areaP"/>
      <path d="${d}" fill="none" stroke="url(#ln)" stroke-width="2.5" stroke-linecap="round" id="lineP" style="filter:drop-shadow(0 0 6px rgba(0,240,255,.5))"/>
      <circle class="dot" r="4" fill="#fff" cx="${X(pts.length-1)}" cy="${Y(pts[pts.length-1])}" opacity="${animate?0:1}" id="dotP"/>`;
    const dot0=svg.querySelector('#dotP');
    if(!animate){ // static final state, just the pulsing endpoint dot (no draw-on, no travel loop)
      if(dot0) dot0.animate([{r:4,opacity:1},{r:7,opacity:.4},{r:4,opacity:1}],{duration:1800,iterations:Infinity});
      return;
    }
    const line=svg.querySelector('#lineP'),len=line.getTotalLength();
    line.style.strokeDasharray=len;line.style.strokeDashoffset=len;line.getBoundingClientRect();
    line.style.transition='stroke-dashoffset 1.6s cubic-bezier(.3,.7,.2,1)';line.style.strokeDashoffset=0;
    setTimeout(()=>{const a=svg.querySelector('#areaP');if(!a)return;a.style.transition='opacity .8s';a.style.opacity=1;
      const dot=svg.querySelector('#dotP');if(dot){dot.style.transition='opacity .5s';dot.style.opacity=1;
      dot.animate([{r:4,opacity:1},{r:7,opacity:.4},{r:4,opacity:1}],{duration:1800,iterations:Infinity});}
      travelAlong(svg,'#lineP','#ffffff',5200);},1300);
  }

  function donut(svg,data,centerText,opts={}){
    if(!svg)return;let cum=0;const animate=opts.animate!==false;
    svg.innerHTML=`<circle cx="21" cy="21" r="15.9" fill="none" stroke="rgba(255,255,255,.05)" stroke-width="5"></circle>`;
    data.forEach(([n,pct,c],i)=>{const ci=document.createElementNS(NS,'circle');
      ci.setAttribute('cx',21);ci.setAttribute('cy',21);ci.setAttribute('r',15.9);ci.setAttribute('fill','none');
      ci.setAttribute('stroke',c);ci.setAttribute('stroke-width',5);ci.setAttribute('stroke-linecap','round');
      ci.setAttribute('stroke-dasharray',animate?'0 100':`${pct} ${100-pct}`);ci.setAttribute('stroke-dashoffset',25-cum);
      if(animate)ci.style.transition=`stroke-dasharray .9s cubic-bezier(.3,.7,.2,1) ${.3+i*.1}s`; // no outer glow — keep segments contained
      ci._t=`${pct} ${100-pct}`;svg.appendChild(ci);cum+=pct;});
    if(centerText){const a=document.createElementNS(NS,'text');a.setAttribute('x',21);a.setAttribute('y',20.5);a.setAttribute('text-anchor','middle');a.setAttribute('fill','#9aa6c7');a.setAttribute('font-size','2.4');a.setAttribute('font-family','JetBrains Mono');a.textContent='TOTAL';
      const b=document.createElementNS(NS,'text');b.setAttribute('x',21);b.setAttribute('y',24);b.setAttribute('text-anchor','middle');b.setAttribute('fill','#e9eefb');b.setAttribute('font-size','3.4');b.setAttribute('font-weight','700');b.setAttribute('font-family','JetBrains Mono');b.textContent=centerText;svg.appendChild(a);svg.appendChild(b);}
    requestAnimationFrame(()=>requestAnimationFrame(()=>{svg.querySelectorAll('circle').forEach(c=>{if(c._t)c.setAttribute('stroke-dasharray',c._t);});}));
  }

  /* sparkline. pts REQUIRED (array of numbers) — renders empty (never fabricated) when absent. */
  function spark(svg,color,pts,opts={}){
    if(!svg)return;const w=200,h=40;const animate=opts.animate!==false;
    if(!Array.isArray(pts)||pts.length<2){_stopTravel(svg);svg.innerHTML='';console.warn('[SPK] spark: no/insufficient data — rendering empty');return;}
    _stopTravel(svg);
    const n=pts.length;
    const mx=Math.max(...pts),mn=Math.min(...pts);let d='';
    pts.forEach((p,i)=>d+=(i?'L':'M')+(i/(n-1)*w).toFixed(1)+' '+(h-2-((p-mn)/(mx-mn||1))*(h-6)).toFixed(1)+' ');
    svg.setAttribute('viewBox',`0 0 ${w} ${h}`);
    svg.innerHTML=`<path d="${d}" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" style="filter:drop-shadow(0 0 4px ${color})"/>`;
    if(!animate)return;
    const p=svg.querySelector('path'),len=p.getTotalLength();p.style.strokeDasharray=len;p.style.strokeDashoffset=len;p.getBoundingClientRect();
    p.style.transition='stroke-dashoffset 1.4s ease .3s';p.style.strokeDashoffset=0;
    setTimeout(()=>travelAlong(svg,'path',color,4200),1600);
  }

  function travelAlong(svg,sel,color,dur){
    const path=svg.querySelector(sel);if(!path)return;const len=path.getTotalLength();
    if(svg._spkRaf){cancelAnimationFrame(svg._spkRaf);svg._spkRaf=null;} // cancel any prior loop (prevents rAF leak on re-render)
    const dot=document.createElementNS(NS,'circle');dot.setAttribute('r',3);dot.setAttribute('fill',color);dot.style.filter=`drop-shadow(0 0 7px ${color})`;svg.appendChild(dot);
    const t0=performance.now();
    (function loop(t){if(!dot.isConnected){svg._spkRaf=null;return;} // node was replaced on re-render → stop
      const p=((t-t0)%dur)/dur,pt=path.getPointAtLength(p*len);
      dot.setAttribute('cx',pt.x);dot.setAttribute('cy',pt.y);dot.setAttribute('opacity',p<.05?p/.05:(p>.95?(1-p)/.05:1));if(motionOK())svg._spkRaf=requestAnimationFrame(loop);})(t0);
  }
  function _stopTravel(svg){if(svg&&svg._spkRaf){cancelAnimationFrame(svg._spkRaf);svg._spkRaf=null;}}

  function injectSheen(){document.querySelectorAll('.panel').forEach(p=>{if(p.querySelector('.sheen'))return;const s=document.createElement('div');s.className='sheen';p.appendChild(s);});}
  function parallax(){const cv=document.getElementById('aurora');if(!cv)return;addEventListener('mousemove',e=>{const dx=e.clientX/innerWidth-.5,dy=e.clientY/innerHeight-.5;cv.style.transform=`translate(${(dx*-20).toFixed(1)}px,${(dy*-20).toFixed(1)}px)`;});}
  function reveal(stagger=70){document.querySelectorAll('.fade').forEach((el,i)=>setTimeout(()=>el.classList.add('in'),80+i*stagger));}
  function flash(el){if(!el)return;el.classList.remove('flash');void el.offsetWidth;el.classList.add('flash');}

  /* original SPEKTRX spectrum mark (neon-treated via .spk-logo css) */
  function logoSVG(s=34){return `<svg viewBox="0 0 34 34" width="${s}" height="${s}">`+
    `<rect x="22" y="4" width="11" height="2.5" rx="1.25" fill="#FF4D6A"/>`+
    `<rect x="15" y="9.5" width="18" height="2.5" rx="1.25" fill="#FF8C42"/>`+
    `<rect x="8" y="15" width="25" height="2.5" rx="1.25" fill="#D4A853"/>`+
    `<rect x="2" y="20.5" width="31" height="2.5" rx="1.25" fill="#7ff0c4"/>`+
    `<rect x="10" y="26" width="23" height="2.5" rx="1.25" fill="#4DC9F6"/>`+
    `<rect x="18" y="31.5" width="15" height="2.5" rx="1.25" fill="#9B4DFF"/></svg>`;}

  /* portfolio heatmap / map — items:[{t,value,pnl}] sized by value, colored by P&L.
     opts.label(it) overrides the number printed on the tile; size and colour never change,
     so the card's "size = position value · color = P&L" caption stays true in every mode. */
  function heatmap(el,items,opts={}){
    if(!el)return;const max=Math.max(...items.map(i=>Math.abs(i.pnl)))||1;const animate=opts.animate!==false;
    el.classList.add('heat');
    el.innerHTML=items.slice().sort((a,b)=>b.value-a.value).map((it,i)=>{
      const span=it.value>2800?'grid-column:span 2;grid-row:span 2':it.value>900?'grid-column:span 2':'';
      const inten=Math.min(Math.abs(it.pnl)/max,1);
      const col=it.pnl>=0?`rgba(52,226,160,${.10+inten*.5})`:`rgba(255,84,112,${.10+inten*.5})`;
      const init=animate?`opacity:0;transform:scale(.85);transition-delay:${i*.03}s`:'opacity:1;transform:scale(1)';
      return `<div class="hmtile" style="${span};background:${col};${init}">
        <div class="t">${it.t}</div><div class="p ${it.pnl>=0?'pos':'neg'}">${opts.label?opts.label(it):((it.pnl>=0?'+':'')+it.pnl+'%')}</div></div>`;}).join('');
    if(animate)requestAnimationFrame(()=>requestAnimationFrame(()=>el.querySelectorAll('.hmtile').forEach(t=>{t.style.opacity=1;t.style.transform='scale(1)';})));
  }

  // ===== motion primitives (reusable across pages) =====
  // live counter: increments by perSec, updated `hz` times/second. Stores interval on el (no dupes).
  function ticker(el, start, perSec, opts = {}) {
    if (!el) return;
    if (el._spkTk) clearInterval(el._spkTk);
    const hz = opts.hz || 20, dec = opts.dec != null ? opts.dec : 2, pre = opts.prefix || '', suf = opts.suffix || '';
    let v = start; const inc = perSec / hz;
    const paint = () => { el.textContent = pre + v.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf; };
    paint(); if (!motionOK()) return; el._spkTk = setInterval(() => { v += inc; paint(); }, 1000 / hz);
  }
  // rolling-digit odometer (digits slide up to their value)
  function odometer(el, value) {
    if (!el) return;
    const s = String(value);
    el.style.display = 'inline-flex'; el.style.alignItems = 'center'; el.style.lineHeight = '1';
    el.innerHTML = s.split('').map(ch => (ch >= '0' && ch <= '9')
      ? `<span class="spk-odc" style="display:inline-block;height:1em;line-height:1em;overflow:hidden"><span style="display:block;transition:transform 1.1s cubic-bezier(.2,.8,.2,1)">${[0,1,2,3,4,5,6,7,8,9].map(n => `<span style="display:block;height:1em">${n}</span>`).join('')}</span></span>`
      : `<span>${ch}</span>`).join('');
    requestAnimationFrame(() => requestAnimationFrame(() => {
      let ci = 0; s.split('').forEach(ch => { if (ch >= '0' && ch <= '9') { const c = el.querySelectorAll('.spk-odc')[ci]; if (c && c.firstChild) c.firstChild.style.transform = `translateY(-${+ch}em)`; ci++; } });
    }));
  }
  // liquid/wave fill inside a container (e.g. a circle). pct 0-100.
  function liquidFill(el, pct, color) {
    if (!el) return; color = color || 'var(--cyan,#00f0ff)';
    if (!document.getElementById('spk-wave-kf')) { const st = document.createElement('style'); st.id = 'spk-wave-kf'; st.textContent = '@keyframes spkwave{from{transform:translateX(0)}to{transform:translateX(-50%)}}'; document.head.appendChild(st); }
    el.style.position = 'relative'; el.style.overflow = 'hidden';
    el.innerHTML = `<div style="position:absolute;bottom:0;left:-50%;width:200%;height:${Math.max(2, Math.min(pct, 100))}%;background:${color};opacity:.4;transition:height 1s cubic-bezier(.2,.7,.2,1)"><div style="position:absolute;top:-8px;left:0;width:50%;height:16px;background:${color};border-radius:50%;animation:spkwave 2.6s linear infinite"></div></div>`;
  }
  function stopTicker(el) { if (el && el._spkTk) { clearInterval(el._spkTk); el._spkTk = null; } }

  return {aurora,countUp,areaChart,donut,spark,travelAlong,injectSheen,parallax,reveal,flash,logoSVG,heatmap,ticker,odometer,liquidFill,stopTicker,motionOK};
})();


export default SPK;
export { SPK };
